import React from "react";
import { BookOpen, Calendar, CheckSquare, BarChart, Shield, LogOut, UserCircle } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { useLanguage } from "../../i18n/LanguageContext";

const BottomNav = ({ activeTab, setActiveTab }) => {
  const { logout, user } = useAuth();
  const { t } = useLanguage();

  const navItems = [
    { id: "journal", icon: BookOpen, label: t("nav.journal") },
    { id: "goals", icon: CheckSquare, label: t("nav.goals") },
    { id: "calendar", icon: Calendar, label: t("nav.calendar") },
    { id: "analytics", icon: BarChart, label: t("nav.analytics") },
    ...(user?.is_admin ? [{ id: "admin", icon: Shield, label: t("nav.admin") }] : []),
    { id: "settings", icon: UserCircle, label: t("nav.profile") },
  ];

  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-30 bg-white border-t border-gray-200 flex items-center justify-around px-1 pb-[env(safe-area-inset-bottom)]">
      {navItems.map(({ id, icon: Icon, label }) => (
        <button
          key={id}
          onClick={() => setActiveTab(id)}
          aria-label={label}
          className={`flex flex-col items-center justify-center flex-1 py-2 min-h-[56px] gap-0.5 transition-colors ${
            activeTab === id
              ? "text-purple-700"
              : "text-gray-400 hover:text-gray-600"
          }`}
        >
          <Icon className="h-5 w-5" />
          <span className="text-[10px] leading-tight truncate max-w-full px-1">{label}</span>
        </button>
      ))}
      <button
        onClick={logout}
        aria-label={t("nav.logout")}
        className="flex flex-col items-center justify-center flex-1 py-2 min-h-[56px] gap-0.5 text-gray-400 hover:text-red-500 transition-colors"
      >
        <LogOut className="h-5 w-5" />
        <span className="text-[10px] leading-tight">{t("nav.logout")}</span>
      </button>
    </nav>
  );
};

export default BottomNav;
